// SPECA Detailing — content & data (Noble Park, Melbourne)
export const BRAND = {
  name: "SPECA Detailing",
  shortName: "SPECA",
  tagline: "Precision in every detail.",
  descriptor: "Premium Automotive Detailing & Paint Protection in Melbourne",
  description:
    "Premium automotive detailing, paint correction and ceramic coating in Noble Park, Melbourne. Mobile and in-house services for luxury and performance vehicles.",
  location: "Noble Park, Melbourne, VIC",
  city: "Melbourne",
  suburb: "Noble Park",
  phone: "0482 853 890",
  phoneRaw: "0482853890",
  email: "specaofficial@gmail.com",
  website: "www.specadetailing.com",
  canonical: "https://www.specadetailing.com",
  instagram: "https://www.instagram.com/speca.detailing/",
  instagramHandle: "@speca.detailing",
  training: "Professionally Trained by XEE Detailing",
  productBrands: ["GYEON", "Koch Chemie", "NXTZEN"],
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Ceramic Coating", to: "/ceramic-coating" },
  { label: "Paint Correction", to: "/paint-correction" },
  { label: "About", to: "/about" },
  { label: "Gallery", to: "/gallery" },
  { label: "Contact", to: "/contact" },
];

export const VEHICLE_SIZES = [
  { id: "small", label: "Small", description: "Hatchback / Coupe", modifier: 0 },
  { id: "medium", label: "Medium", description: "Sedan / Small SUV", modifier: 40 },
  { id: "large", label: "Large", description: "Large SUV / 7-Seater", modifier: 80 },
];

// Featured services on home (4 cards)
export const FEATURED_SERVICES = [
  { id: "maintenance", name: "Maintenance Detail", price: "From $159", blurb: "Regular interior and exterior care to maintain your vehicle's appearance.", href: "/services#maintenance" },
  { id: "signature", name: "Signature Detail", price: "From $299", blurb: "Complete interior and exterior detail with targeted steam cleaning and paint sealant protection.", href: "/services#signature", recommended: true },
  { id: "ultimate", name: "Ultimate Detail", price: "From $499", blurb: "Comprehensive detail with single-stage paint enhancement and interior protection.", href: "/services#ultimate" },
  { id: "ceramic", name: "Ceramic Coating", price: "From $799", blurb: "Professional ceramic protection designed to enhance gloss and make maintenance easier.", href: "/ceramic-coating" },
];

// Full detailing packages (price estimator eligible)
export const DETAIL_PACKAGES = [
  {
    id: "maintenance",
    name: "SPECA Maintenance",
    base: 159,
    duration: "1.5–2.5 hours",
    tagline: "Designed for regularly maintained vehicles. Recommended every 2–4 weeks.",
    features: [
      "Premium exterior hand wash",
      "Wheel and tyre cleaning",
      "Tyre dressing",
      "Interior vacuum",
      "Dashboard, centre console and door trim wipe-down",
      "Interior and exterior glass cleaning",
      "Door jamb wipe-down",
    ],
  },
  {
    id: "signature",
    name: "SPECA Signature Detail",
    base: 299,
    duration: "4–6 hours",
    tagline: "Recommended for first-time customers. A complete interior and exterior reset.",
    recommended: true,
    features: [
      "Everything in SPECA Maintenance",
      "Thorough interior vacuum, including tight areas",
      "Detailed interior surface cleaning",
      "Targeted steam cleaning",
      "Leather or fabric seat surface cleaning",
      "Carpet and floor mat surface cleaning",
      "Exterior chemical decontamination as required",
      "Koch Chemie ProtectorWax paint sealant (up to 6 months)",
      "Basic interior plastic and vinyl protection",
    ],
  },
  {
    id: "ultimate",
    name: "SPECA Ultimate Detail",
    base: 499,
    duration: "6–9 hours",
    tagline: "Includes single-stage paint enhancement and NXTZEN interior protection.",
    features: [
      "Everything in Signature Detail",
      "More extensive interior detailing",
      "Detailed wheel and exterior decontamination",
      "Single-stage machine paint enhancement",
      "Premium paint sealant",
      "NXTZEN interior protection on compatible surfaces",
    ],
    note: "Paint enhancement improves gloss and light defects but does not guarantee complete scratch removal.",
  },
];

export const INTERIOR_PACKAGES = [
  {
    id: "interior-refresh",
    name: "Interior Refresh",
    base: 129,
    features: [
      "Full interior vacuum",
      "Dashboard, console and door trim cleaning",
      "Interior glass cleaning",
      "Floor mat cleaning",
      "Light interior surface wipe-down",
    ],
  },
  {
    id: "interior-deep",
    name: "Interior Deep Detail",
    base: 229,
    features: [
      "Thorough interior vacuum and air blowout",
      "Targeted steam cleaning",
      "Leather or fabric seat surface cleaning",
      "Carpet and floor mat surface cleaning",
      "Dashboard, vents and console detailing",
      "Interior glass cleaning",
      "Basic interior plastic and vinyl protection",
    ],
  },
];

export const EXTERIOR_PACKAGES = [
  {
    id: "exterior-maintenance",
    name: "Exterior Maintenance",
    base: 109,
    features: [
      "Pre-wash and snow foam",
      "Safe contact wash",
      "Wheel and tyre cleaning",
      "Door jamb wipe-down",
      "Exterior glass cleaning",
      "Tyre dressing",
    ],
  },
  {
    id: "exterior-protection",
    name: "Exterior Protection",
    base: 199,
    features: [
      "Everything in Exterior Maintenance",
      "Chemical paint decontamination",
      "Spot tar removal as required",
      "Koch Chemie ProtectorWax paint sealant",
      "Enhanced gloss and water repellency",
    ],
  },
];

export const PAINT_CORRECTION = [
  {
    id: "single-stage",
    name: "Single-Stage Paint Enhancement",
    base: 399,
    tagline: "Improve paint gloss, clarity and light swirl marks.",
    features: [
      "Full wash and decontamination",
      "Single-stage machine polish",
      "Light swirl and defect removal",
      "Panel wipe and finishing",
    ],
  },
  {
    id: "two-stage",
    name: "Two-Stage Paint Correction",
    base: 699,
    tagline: "More intensive polishing for moderate swirl marks and paint defects.",
    features: [
      "Full wash and decontamination",
      "Compound stage for defect removal",
      "Refining stage for maximum gloss",
      "Panel wipe and finishing",
    ],
    note: "Results depend on paint condition, thickness and existing defects. Not all scratches can be safely removed.",
  },
];

export const CERAMIC_PACKAGES = [
  {
    id: "speca-one",
    name: "SPECA ONE",
    duration: "1 Year Protection",
    tier: "Entry-Level Ceramic Protection",
    description: "Full exterior preparation, single-stage paint enhancement and a 1-year ceramic coating.",
    prices: { small: 799, medium: 899, large: 999 },
    leadIn: null,
    inclusionGroups: [
      {
        title: "Exterior Preparation",
        items: [
          "Full vehicle pre-rinse",
          "Snow foam pre-wash",
          "pH-neutral hand wash",
          "Wheels, tyres and wheel arches cleaned",
          "Door jambs and fuel filler area cleaned",
          "Bug and road grime removal",
          "Iron fallout removal",
          "Tar and adhesive contamination removal where required",
          "Clay bar decontamination where required",
          "Paint surface preparation and panel wipe",
        ],
      },
      {
        title: "Paint Enhancement",
        items: [
          "Single-stage machine paint enhancement",
          "Reduction of light swirl marks",
          "Improved gloss and paint clarity",
        ],
      },
      {
        title: "Ceramic Protection",
        items: [
          "1-year ceramic coating applied to painted exterior panels",
          "Hydrophobic water-repellent finish",
          "Easier ongoing washing and maintenance",
        ],
      },
      {
        title: "Final Touches",
        items: [
          "Exterior glass cleaned",
          "Exterior plastic trims cleaned and dressed",
          "Tyre dressing",
          "Final quality inspection",
          "Coating maintenance instructions",
        ],
      },
    ],
  },
  {
    id: "speca-pro",
    name: "SPECA PRO",
    duration: "3 Year Protection",
    tier: "Long-Lasting Ceramic Protection",
    description: "Single-stage paint correction, a 3-year ceramic coating and added trim, wheel and glass protection.",
    popular: true,
    prices: { small: 1099, medium: 1199, large: 1349 },
    leadIn: "Includes the complete SPECA ONE exterior preparation process.",
    inclusionGroups: [
      {
        title: "Paint Correction",
        items: [
          "Single-stage machine paint correction",
          "Reduction of light to moderate swirl marks",
          "Improvement of minor surface scratches where safely achievable",
          "Improved paint gloss, depth and clarity",
          "Final panel preparation before coating",
        ],
      },
      {
        title: "Ceramic Protection",
        items: [
          "3-year ceramic coating applied to painted exterior panels",
          "Enhanced water repellency",
          "Improved ease of cleaning",
          "Longer-lasting paint protection",
        ],
      },
      {
        title: "Additional Protection",
        items: [
          "Exterior plastic trim protection",
          "Wheel faces cleaned and protected with a suitable sealant",
          "Exterior glass thoroughly cleaned",
        ],
      },
      {
        title: "Final Touches",
        items: [
          "Tyre dressing",
          "Detailed exterior finishing",
          "Final coating quality inspection",
          "Ceramic coating maintenance instructions",
        ],
      },
    ],
  },
  {
    id: "speca-premium",
    name: "SPECA PREMIUM",
    duration: "5+ Year Protection",
    tier: "Flagship Ceramic Protection",
    description: "Two-stage paint correction with a 5+ year coating system, plus ceramic protection for wheels, glass and trim.",
    prices: { small: 1899, medium: 2099, large: 2299 },
    leadIn: "Includes the complete exterior cleaning and decontamination process.",
    inclusionGroups: [
      {
        title: "Advanced Paint Correction",
        items: [
          "Detailed paint condition inspection",
          "Two-stage machine paint correction",
          "Cutting stage for eligible moderate paint defects",
          "Refinement stage to improve gloss and clarity",
          "Reduction of swirl marks and surface imperfections",
          "Final finishing polish",
          "Full coating preparation and panel wipe",
        ],
      },
      {
        title: "Premium Ceramic Protection",
        items: [
          "5+ year ceramic paint protection using an appropriate coating system",
          "Application to all painted exterior panels",
          "High-gloss hydrophobic finish",
          "Long-term protection and easier maintenance",
        ],
      },
      {
        title: "Additional Ceramic Protection",
        items: [
          "Ceramic coating on exterior wheel faces",
          "Ceramic coating on accessible wheel barrels",
          "Ceramic coating on exterior glass",
          "Windscreen hydrophobic protection",
          "Exterior plastic and trim protection",
          "Exterior light lens protection where compatible",
        ],
      },
      {
        title: "Premium Finishing",
        items: [
          "Detailed door jamb cleaning",
          "Wheels and tyres finished",
          "Final paintwork inspection",
          "Ceramic coating application quality check",
          "Personalised aftercare recommendations",
        ],
      },
    ],
  },
];

export const CERAMIC_COMPARISON = [
  { feature: "Durability", values: ["1 Year", "3 Years", "5+ Years"] },
  { feature: "From price (small vehicle)", values: ["$799", "$1,099", "$1,899"] },
  { feature: "Full exterior wash & decontamination", values: ["yes", "yes", "yes"] },
  { feature: "Paint work", values: ["Single-stage paint enhancement", "Single-stage paint correction", "Two-stage paint correction"] },
  { feature: "Ceramic coating on painted panels", values: ["yes", "yes", "yes"] },
  { feature: "Exterior plastic trim protection", values: ["no", "yes", "Ceramic protection"] },
  { feature: "Wheel faces", values: ["Cleaned", "Cleaned & sealant protected", "Ceramic coated"] },
  { feature: "Wheel barrels ceramic coating", values: ["no", "no", "yes"] },
  { feature: "Exterior glass", values: ["Cleaned", "Thoroughly cleaned", "Ceramic coated"] },
  { feature: "Windscreen hydrophobic protection", values: ["no", "no", "yes"] },
  { feature: "Exterior light lens protection", values: ["no", "no", "Where compatible"] },
  { feature: "Aftercare & maintenance guidance", values: ["yes", "yes", "Personalised recommendations"] },
];

export const INTERIOR_ADDONS = [
  { id: "leather", name: "Leather Cleaning & Protection", price: 89, display: "$89" },
  { id: "complete-interior", name: "Complete Interior Protection Treatment", price: 119, display: "$119" },
  { id: "steam", name: "Targeted Steam Cleaning", price: 49, display: "$49" },
  { id: "pet-hair", name: "Pet Hair Removal", price: 49, display: "$49–$99", range: true },
  { id: "sand", name: "Heavy Sand / Debris Removal", price: 40, display: "$40–$80", range: true },
];

export const EXTERIOR_ADDONS = [
  { id: "engine-bay", name: "Engine Bay Detail", price: 79, display: "$79" },
  { id: "bug-tar", name: "Bug & Tar Removal", price: 39, display: "$39" },
  { id: "iron", name: "Iron Fallout Decontamination", price: 49, display: "$49" },
  { id: "trim", name: "Exterior Plastic Trim Restoration", price: 79, display: "From $79" },
  { id: "windscreen", name: "Windscreen Glass Coating", price: 99, display: "$99" },
  { id: "glass-full", name: "Full Exterior Glass Coating", price: 199, display: "$199" },
  { id: "wheel-face", name: "Wheel Face Ceramic Coating", price: 199, display: "$199" },
  { id: "wheels-calipers", name: "Wheels & Calipers Ceramic Coating", price: 449, display: "From $449" },
];

export const FAQ = [
  { q: "How long does a Signature Detail take?", a: "Approximately 4–6 hours, depending on vehicle condition." },
  { q: "Do you offer mobile detailing?", a: "Mobile detailing is available subject to location, suitable working conditions and access to required utilities. Some services require an appropriate indoor workspace." },
  { q: "Do you offer seat shampooing?", a: "We currently offer professional seat surface cleaning but do not provide extraction or deep wet-shampoo services." },
  { q: "How long does ceramic coating last?", a: "Durability depends on the selected package, specific coating product, environmental conditions and maintenance." },
  { q: "Will paint correction remove every scratch?", a: "Paint correction can reduce many visible defects, but results depend on the paint condition and safe correction limits." },
  { q: "Do I need a Signature Detail before Maintenance?", a: "First-time customers are generally recommended to book a Signature Detail. Maintenance is intended for vehicles already in good condition." },
];

export const POLICIES = [
  "All prices are starting prices in AUD.",
  "Final pricing depends on vehicle size, condition and required labour.",
  "Heavy contamination, excessive pet hair and significant staining may incur additional charges.",
  "Bookings are subject to confirmation.",
  "Mobile detailing may incur travel charges.",
  "Ceramic coating application and curing require suitable environmental conditions.",
  "Paint correction results vary depending on vehicle condition.",
  "Product protection and durability claims are subject to manufacturer specifications and maintenance requirements.",
];

export const GALLERY_CATEGORIES = [
  { id: "all", label: "All Work" },
  { id: "exterior", label: "Exterior Detailing" },
  { id: "interior", label: "Interior Detailing" },
  { id: "correction", label: "Paint Correction" },
  { id: "ceramic", label: "Ceramic Coating" },
  { id: "performance", label: "Performance & Luxury" },
];

// Service options for booking form dropdown
export const ALL_SERVICE_IDS = [
  ...DETAIL_PACKAGES.map((p) => ({ id: p.id, name: p.name, base: p.base })),
  ...INTERIOR_PACKAGES.map((p) => ({ id: p.id, name: p.name, base: p.base })),
  ...EXTERIOR_PACKAGES.map((p) => ({ id: p.id, name: p.name, base: p.base })),
  ...PAINT_CORRECTION.map((p) => ({ id: p.id, name: p.name, base: p.base })),
  { id: "ceramic-one", name: "Ceramic — SPECA ONE", base: 799 },
  { id: "ceramic-pro", name: "Ceramic — SPECA PRO", base: 1099 },
  { id: "ceramic-premium", name: "Ceramic — SPECA PREMIUM", base: 1899 },
];

export const ALL_ADDONS = [...INTERIOR_ADDONS, ...EXTERIOR_ADDONS];
